import React from "react";
import "./style.scss";
import handicon from "../../../images/hand.png";
import myimage from "../../../images/me.jpeg";
import Typewriter from "typewriter-effect";

const IntroContent = () => {
    return (
        <div id="home" className="intro-content-wrapper">
            <div className="layout">
                <div className="intro-left-content">
                    <h1 className="greeting">
                        HI, I AM 
                        <img src={handicon} alt="hand icon" className="hand-icon" />
                    </h1>
                    <h2 className="main-name">Arjun Pratap</h2>

                    <h3 className="hero-role-typewriter">
                        I am a{' '}
                        <Typewriter
                            options={{
                                autoStart: true,
                                loop: true,
                                delay: 40,
                                strings: [
                                    "Full Stack Developer",
                                    "AI & Forward Deployed Engineer",
                                    "Agentic AI Specialist",
                                    "MERN Stack Expert",
                                    "Director of AI Solutions"
                                ],
                                wrapperClassName: "typewriter-text",
                                cursorClassName: "typewriter-cursor"
                            }}
                        />
                    </h3>

                    <p className="bio-summary">
                        Full Stack Developer and Forward Deployed Engineer with <strong>4+ years of experience</strong> building and deploying production web applications and custom AI systems. I have successfully shipped <strong>6 live end-to-end products</strong>, translating business requirements into custom MERN stack, CMS-driven, and <strong>Agentic AI solutions</strong>.
                    </p>
                </div>

                <div className="intro-right-content">
                    <div className="profile-image-container">
                        <div className="blob-border">
                            <img src={myimage} alt="Arjun Pratap Profile" className="profile-image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntroContent;